/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { ServiceDeskOrganizationPanel as ServiceDeskOrganizationPanelType } from '@jira/forge__forge-ui-types/src/common/types/extension.tsx';
import {
	type RouteResource,
	type RouterContext,
	createResource,
} from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_ORGANIZATION_PANEL_FORGE_DATA } from './resourceTypeOrganizationPanelForgeData.constants.tsx';

export const serviceDeskOrganizationPanelForgeDataResource: RouteResource<
	ServiceDeskOrganizationPanelType[] | null
> = createResource<ServiceDeskOrganizationPanelType[] | null>({
	type: RESOURCE_TYPE_ORGANIZATION_PANEL_FORGE_DATA,
	getKey: ({ match }: RouterContext) => {
		const { projectKey } = match.params;
		return `extension-${projectKey}`;
	},
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-servicedesk-organization-panel", jiraSpaEntry: "async-resource-servicedesk-organization-panel" */ './fetchFn.tsx'
		),
	maxAge: Number.MAX_SAFE_INTEGER,
	isBrowserOnly: true,
});
